import Table from '@tiptap/extension-table';

export const TableExtension = Table.extend({
  content: 'tableRow+',
  tableRole: 'table',
  isolating: true,
  group: 'block',
  selectable: true,
  draggable: true,

  addAttributes() {
    return {
      ...this.parent?.(),
      style: {
        default: null,
        renderHTML: () => ({
          style:
            'border-color: #84AFEF; border-collapse: collapse; width: 100%; position: relative;',
        }),
      },
    };
  },
});
